import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import {
  TaxRegisterBlockService,
  taxRegisterBlockText,
} from 'src/app/common/tax/services/tax-register-block.service';

// "Support is working on your tax register" over every window while an admin blocks a register.
// Does not take clicks: the rest of the app works, only fiscal operations are refused.
@Component({
  selector: 'app-tax-block-banner',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="tax-block" *ngIf="(blocks.blocks$ | async)?.length" role="status">
      <div class="tax-block__line" *ngFor="let block of blocks.blocks$ | async">
        <span class="tax-block__icon">🛠</span>
        <span>{{ text(block) }}</span>
      </div>
    </div>
  `,
  styles: [
    `
      .tax-block {
        position: fixed;
        z-index: 2147481000;
        top: calc(6px + env(safe-area-inset-top, 0px));
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        gap: 4px;
        width: max-content;
        max-width: calc(100vw - 24px - env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px));
        pointer-events: none;
      }
      .tax-block__line {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 12px;
        border-radius: 8px;
        background: var(--ion-color-warning, #ffc409);
        color: var(--ion-color-warning-contrast, #000);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
        font-size: 13px;
        line-height: 1.3;
      }
    `,
  ],
})
export class TaxBlockBannerComponent implements OnInit, OnDestroy {
  readonly text = taxRegisterBlockText;
  private _refresh?: Subscription;

  constructor(public blocks: TaxRegisterBlockService) {}

  // Blocks are per company: read again now and then, so a company switch shows its own.
  ngOnInit(): void {
    this._refresh = interval(15_000).subscribe(() => this.blocks.refresh());
  }

  ngOnDestroy(): void {
    this._refresh?.unsubscribe();
  }
}
